import { render, staticRenderFns } from "./yunshubb.vue?vue&type=template&id=8f5dcb3a&scoped=true&"
import script from "./yunshubb.vue?vue&type=script&lang=js&"
export * from "./yunshubb.vue?vue&type=script&lang=js&"
import style0 from "./yunshubb.vue?vue&type=style&index=0&id=8f5dcb3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5dcb3a",
  null
  
)

export default component.exports